import { ModuleItemType } from '@app/store/shared';
import { ModuleDto, DurationDto, DurationItemDto, NextModuleItemDto, ModuleItemDto } from './module.dto';

export class Module {
    id: string;
    name: string;
    items: ModuleItem[];
    next: NextModuleItem | null;
    description: string;
    duration: Duration;

    constructor(data: ModuleDto) {
        this.id = data.id;
        this.name = data.name;
        this.items = data.items.map((itemDto) => new ModuleItem(itemDto));
        this.next = data.next ? new NextModuleItem(data.next) : null;
        this.description = data.description;
        this.duration = new Duration(data.duration);
    }
}

export class ModuleItem {
    id: string;
    name: string;
    type: ModuleItemType;
    image: null | string;
    questionText: null | string;

    constructor(data: ModuleItemDto) {
        this.id = data.id;
        this.name = data.name;
        this.type = data.type;
        this.image = data.image;
        this.questionText = data.questionText;
    }
}

export class Duration {
    video: DurationItem;
    audio: DurationItem;
    document: DurationItem;

    constructor(data: DurationDto) {
        this.video = new DurationItem(data.video);
        this.audio = new DurationItem(data.audio);
        this.document = new DurationItem(data.document);
    }
}

export class DurationItem {
    total: number;
    completed: number;
    remaining: number;

    constructor(data: DurationItemDto) {
        this.total = data.total;
        this.completed = data.completed;
        this.remaining = data.total - data.completed;
    }
}

export class NextModuleItem {
    id: string;
    type: ModuleItemType;

    constructor(data: NextModuleItemDto) {
        this.id = data.id;
        this.type = data.type;
    }
}
